import PropTypes from 'prop-types';
import { CalendarBlank } from '@phosphor-icons/react';
import { Heading, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { IconWrapper } from './ItineraryComponents';

const headingWrapperStyles = css`
  padding-inline: 20px 16px;
`;

const durationInDaysStyles = css`
  display: flex;
  justify-content: end;
  padding-inline-end: 8px;
  width: 89px;
`;

const calenderIconStyles = css`
  background-color: #fff;
`;

const ItineraryDateDurationInfo = ({ calenderDate, durationInDays }) => {
  return (
    <>
      <div className={durationInDaysStyles} data-testid="tripDetails-dateduration-durationInDays">
        {durationInDays && <p>{durationInDays}</p>}
      </div>
      <Inline noWrap spacing={0}>
        <IconWrapper>
          <CalendarBlank className={calenderIconStyles} size={18} weight="regular" />
        </IconWrapper>
        <div className={headingWrapperStyles}>
          <Heading data-testid="tripDetails-dateduration-date" level={4}>
            {calenderDate}
          </Heading>
        </div>
      </Inline>
    </>
  );
};

ItineraryDateDurationInfo.propTypes = {
  calenderDate: PropTypes.string,
  durationInDays: PropTypes.string,
};

export default ItineraryDateDurationInfo;
